import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  place-items: center;
`;

export const Content = styled.div`
  background-color: #fff;
  margin: 1em auto;
  padding: 1em;
  border-radius: 4px;

  @media (max-width: 768px) {
  }
  @media (max-width: 425px) {
    max-width: 360px;
    margin: 0 auto;
  }

  @media (max-width: 375px) {
    max-width: 310px;
    margin: 0 auto;
  }


  @media (max-width: 320px) {
    max-width: 260px;
  }
`;

export const ErrorMessage = styled.p`
  color: #f73450;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  display: block;
`;
